import { motion, Variants } from 'framer-motion';

import Icon from './icon/Icon';
import { Button } from './ui/button';
import Tooltip from './Tooltip';
import { cn } from 'lib/utils';

const navVariants: Variants = {
  closed: {
    height: 0,
    opacity: 0,
  },
  open: {
    height: 'auto',
    opacity: 1,
  },
};

interface ButtonProps {
  icon: string;
  name: string;
  className?: string;
  size?: number | undefined;
  onClick: () => void;
  disabled: boolean;
  isExpanded: boolean;
  isActive: boolean;
}

export function NavButton({
  icon,
  name,
  className,
  size,
  onClick,
  disabled,
  isExpanded,
  isActive,
}: ButtonProps) {
  return (
    <Button
      id={icon}
      aria-label={icon}
      variant='ghost'
      className={cn(
        'justify-start w-full hover:text-white hover:bg-transparent px-0',
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {isExpanded ? (
        <>
          <div className='size-8 mt-2'>
            <Icon
              icon={icon}
              size={size ?? 20}
              color={disabled ? '#fff' : isActive ? '#10A4B1' : '#fff'}
              data-testid={icon}
            />
          </div>
          <motion.p
            variants={navVariants}
            transition={{
              delay: 0.1,
              duration: 0.5,
              ease: 'easeInOut',
              y: { stiffness: 1000 },
            }}
            className='ml-2 tracking-wide text-inherit font-poppins overflow-clip whitespace-nowrap'
            style={{ color: disabled ? '#fff' : isActive ? '#10A4B1' : '#fff' }}
          >
            {name}
          </motion.p>
        </>
      ) : (
        <Tooltip content={name} side='right'>
          <div className='grid size-16 place-items-center'>
            <Icon
              icon={icon}
              size={size ?? 24}
              color={disabled ? '#fff' : isActive ? '#10A4B1' : '#fff'}
              data-testid={icon}
            />
          </div>
        </Tooltip>
      )}
    </Button>
  );
}
